// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Z-Index Hierarchy
 * ==================
 * This file uses the following z-index scale to manage layering:
 *
 * 100  - Details panel overlay (chatview-details-container.overlay)
 * 1000 - Attachment background overlay (chatview-attachment-background)
 * 1500 - Modal portal container (#modal-portal-container)
 * 2000 - Room settings overlay (chatview-room-settings-overlay)
 *
 * This hierarchy ensures proper stacking of overlays and modals.
 */

.chatview {
  height: 100%;
  width: 100%;
}

.chatview-top-bar-container {
  height: 56px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.chatview-top-bar-container.edit {
  height: 74px;
}

.chatview-content {
  position: relative; /* Enable absolute positioning for overlay children */
  display: flex;
  flex-direction: row;
  height: calc(100% - 56px);
  width: 100%;
}

.chatview-content.edit {
  height: calc(100% - 74px);
}


.chatview-details-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 320px;
  position: relative;
  z-index: 50;
}

.chatview-details-container.overlay {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);
  background: var(--color-background-primary, #ffffff);
}

.chatview-messages-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: calc(100% - 320px);
  position: relative;
  z-index: 5;
}

/* Edit mode header with name/topic */
.chatview-details-edit-header {
  flex-shrink: 0; /* Don't shrink header */
  padding: 16px;
  border-bottom: 1px solid var(--color-border-primary, #e0e0e0);
  background: var(--color-background-primary, #ffffff);
  position: relative;
  z-index: 1;
}

.chatview-details-edit-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--color-text-primary, #000000);
  margin-bottom: 4px;
  word-wrap: break-word;
}

.chatview-details-edit-topic-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-secondary, #666666);
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.chatview-details-edit-topic {
  font-size: 14px;
  color: var(--color-text-secondary, #666666);
  word-wrap: break-word;
}

.chatview-details-edit-topic-input {
  width: 100%;
  padding: 10px 12px;
  font-family: 'roboto', sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: var(--color-text-primary, #000000);
  background: var(--color-background-secondary, #f5f5f5);
  border: 1px solid var(--color-border-primary, #e0e0e0);
  border-radius: 8px;
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s ease-in-out;
}

.chatview-details-edit-topic-charcount {
  font-size: 12px;
  color: var(--color-text-secondary, #666666);
  margin-top: 4px;
  text-align: right;
}

.chatview-details-edit-topic-input:hover {
  border-color: var(--color-border-secondary, #d0d0d0);
  background: var(--color-background-primary, #ffffff);
}

.chatview-details-edit-topic-input:focus {
  border-color: var(--color-primary, #0066cc);
  background: var(--color-background-primary, #ffffff);
  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
}

.chatview-details-edit-topic-input::placeholder {
  color: var(--color-text-tertiary, #999999);
  font-style: italic;
}


/* Scrollable contacts section in edit mode */
.chatview-details-edit-contacts {
  flex: 1; /* Take remaining space */
  min-height: 0; /* Required for flex child to scroll */
  position: relative;
  z-index: 2;
}

.chatview-messages-container.fill {
  width: 100%;
}

.chatview-blank {
  height: 100%;
  width: 100%;
  background: var(--color-background-primary, #ffffff);
}

.chatview-attachment-background {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.chatview-attachment-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* This container will hold the modals and is positioned relative to the messages area */
#modal-portal-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* Allow clicks to pass through to the messages list */
  z-index: 1500; /* Ensure it's above messages but below other UI elements if needed */
}

.chatview-room-settings-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chatview-room-settings-overlay > * {
  width: 900px;
  height: 600px;
  max-width: 90%;
  max-height: 90%;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  overflow: hidden;
}


.chatview-details-server-notice-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  background-color: #F8F9FA;
  border-radius: 8px;
  margin: 0 16px 16px 16px;
}

.chatview-details-server-notice-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.chatview-details-server-notice-icon ion-icon {
  font-size: 24px;
  color: #6C757D;
}

.chatview-details-server-notice-text {
  flex: 1;
  margin: 0;
  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #495057;
  line-height: 1.5;
}

/* Loading overlay for jump-to-event (pinned message navigation) */
.chatview-jump-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.7);
  z-index: 5;
}

.chatview-jump-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e0e0e0;
  border-top-color: #666;
  border-radius: 50%;
  animation: chatview-spin 0.8s linear infinite;
}

@keyframes chatview-spin {
  to { transform: rotate(360deg); }
}

.chatview-jump-error {
  font-size: 14px;
  color: #666;
  background: rgba(255, 255, 255, 0.9);
  pointer-events: none;
  animation: chatview-fade-out 3s ease-in forwards;
}

@keyframes chatview-fade-out {
  0%, 70% { opacity: 1; }
  100% { opacity: 0; }
}
`, "",{"version":3,"sources":["webpack://./src/components/Page/Conversations/ChatView/ChatView.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;AAEF;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB,EAAE,qDAAqD;EACzE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,YAAY;EACZ,2CAA2C;EAC3C,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,cAAc,EAAE,wBAAwB;EACxC,aAAa;EACb,6DAA6D;EAC7D,oDAAoD;EACpD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,2CAA2C;EAC3C,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,yCAAyC;EACzC,sDAAsD;EACtD,sDAAsD;EACtD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,oDAAoD;AACtD;;AAEA;EACE,2CAA2C;EAC3C,oDAAoD;EACpD,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;;AAGA,6CAA6C;AAC7C;EACE,OAAO,EAAE,yBAAyB;EAClC,aAAa,EAAE,sCAAsC;EACrD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oDAAoD;AACtD;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA,wFAAwF;AACxF;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB,EAAE,sDAAsD;EAC5E,aAAa,EAAE,qEAAqE;AACtF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,SAAS;EACT,gGAAgG;EAChG,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,oCAAoC;EACpC,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,OAAO,UAAU,EAAE;AACrB","sourcesContent":["/*\n * Z-Index Hierarchy\n * ==================\n * This file uses the following z-index scale to manage layering:\n *\n * 100  - Details panel overlay (chatview-details-container.overlay)\n * 1000 - Attachment background overlay (chatview-attachment-background)\n * 1500 - Modal portal container (#modal-portal-container)\n * 2000 - Room settings overlay (chatview-room-settings-overlay)\n *\n * This hierarchy ensures proper stacking of overlays and modals.\n */\n\n.chatview {\n  height: 100%;\n  width: 100%;\n}\n\n.chatview-top-bar-container {\n  height: 56px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n}\n\n.chatview-top-bar-container.edit {\n  height: 74px;\n}\n\n.chatview-content {\n  position: relative; /* Enable absolute positioning for overlay children */\n  display: flex;\n  flex-direction: row;\n  height: calc(100% - 56px);\n  width: 100%;\n}\n\n.chatview-content.edit {\n  height: calc(100% - 74px);\n}\n\n\n.chatview-details-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 320px;\n  position: relative;\n  z-index: 50;\n}\n\n.chatview-details-container.overlay {\n  position: absolute;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  z-index: 100;\n  box-shadow: -4px 0 12px rgba(0, 0, 0, 0.15);\n  background: var(--color-background-primary, #ffffff);\n}\n\n.chatview-messages-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: calc(100% - 320px);\n  position: relative;\n  z-index: 5;\n}\n\n/* Edit mode header with name/topic */\n.chatview-details-edit-header {\n  flex-shrink: 0; /* Don't shrink header */\n  padding: 16px;\n  border-bottom: 1px solid var(--color-border-primary, #e0e0e0);\n  background: var(--color-background-primary, #ffffff);\n  position: relative;\n  z-index: 1;\n}\n\n.chatview-details-edit-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--color-text-primary, #000000);\n  margin-bottom: 4px;\n  word-wrap: break-word;\n}\n\n.chatview-details-edit-topic-label {\n  display: block;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--color-text-secondary, #666666);\n  margin-bottom: 8px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.chatview-details-edit-topic {\n  font-size: 14px;\n  color: var(--color-text-secondary, #666666);\n  word-wrap: break-word;\n}\n\n.chatview-details-edit-topic-input {\n  width: 100%;\n  padding: 10px 12px;\n  font-family: 'roboto', sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--color-text-primary, #000000);\n  background: var(--color-background-secondary, #f5f5f5);\n  border: 1px solid var(--color-border-primary, #e0e0e0);\n  border-radius: 8px;\n  outline: none;\n  box-sizing: border-box;\n  transition: all 0.2s ease-in-out;\n}\n\n.chatview-details-edit-topic-charcount {\n  font-size: 12px;\n  color: var(--color-text-secondary, #666666);\n  margin-top: 4px;\n  text-align: right;\n}\n\n.chatview-details-edit-topic-input:hover {\n  border-color: var(--color-border-secondary, #d0d0d0);\n  background: var(--color-background-primary, #ffffff);\n}\n\n.chatview-details-edit-topic-input:focus {\n  border-color: var(--color-primary, #0066cc);\n  background: var(--color-background-primary, #ffffff);\n  box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);\n}\n\n.chatview-details-edit-topic-input::placeholder {\n  color: var(--color-text-tertiary, #999999);\n  font-style: italic;\n}\n\n\n/* Scrollable contacts section in edit mode */\n.chatview-details-edit-contacts {\n  flex: 1; /* Take remaining space */\n  min-height: 0; /* Required for flex child to scroll */\n  position: relative;\n  z-index: 2;\n}\n\n.chatview-messages-container.fill {\n  width: 100%;\n}\n\n.chatview-blank {\n  height: 100%;\n  width: 100%;\n  background: var(--color-background-primary, #ffffff);\n}\n\n.chatview-attachment-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n}\n\n.chatview-attachment-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n/* This container will hold the modals and is positioned relative to the messages area */\n#modal-portal-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none; /* Allow clicks to pass through to the messages list */\n  z-index: 1500; /* Ensure it's above messages but below other UI elements if needed */\n}\n\n.chatview-room-settings-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.chatview-room-settings-overlay > * {\n  width: 900px;\n  height: 600px;\n  max-width: 90%;\n  max-height: 90%;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n}\n\n\n.chatview-details-server-notice-info {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  background-color: #F8F9FA;\n  border-radius: 8px;\n  margin: 0 16px 16px 16px;\n}\n\n.chatview-details-server-notice-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.chatview-details-server-notice-icon ion-icon {\n  font-size: 24px;\n  color: #6C757D;\n}\n\n.chatview-details-server-notice-text {\n  flex: 1;\n  margin: 0;\n  font-family: 'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 14px;\n  font-weight: 400;\n  color: #495057;\n  line-height: 1.5;\n}\n\n/* Loading overlay for jump-to-event (pinned message navigation) */\n.chatview-jump-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: 5;\n}\n\n.chatview-jump-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e0e0e0;\n  border-top-color: #666;\n  border-radius: 50%;\n  animation: chatview-spin 0.8s linear infinite;\n}\n\n@keyframes chatview-spin {\n  to { transform: rotate(360deg); }\n}\n\n.chatview-jump-error {\n  font-size: 14px;\n  color: #666;\n  background: rgba(255, 255, 255, 0.9);\n  pointer-events: none;\n  animation: chatview-fade-out 3s ease-in forwards;\n}\n\n@keyframes chatview-fade-out {\n  0%, 70% { opacity: 1; }\n  100% { opacity: 0; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
